/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState, useRef } from 'react';
import { ARMcontext, useViewport } from '../../../utils/context/context';
import { FluidContainer, Loader, TooltipLocations } from '../../../components';
import { default as ActionItemCard } from './actionItemCard';
import {
  ActionItemColumn,
  ActionItemContainer,
} from './styles';
import { Teams } from '../../../utils/api';
import { CacheKeysTables, KeyActionItemsCache } from '../../../utils/constants/keyCache';

export default ({
  isFirstLoad,
  playersGroup,
  playerNameSearch
}: {
  isFirstLoad: boolean,
  playersGroup: any,
  playerNameSearch: string,
}) => {
  const [actionItems, useActionItems] = useState<any>({});
  const { selectedTeam, reload, triggerRefresh, setTriggerRefresh } = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const [isFirstLoadActionsItems, setFirstLoadActionsItems] = useState(true);
  const [currentPlayerNameSearch, setCurrentPlayerNameSearch] = useState(playerNameSearch);
  const TEAMS = new Teams();

  const { width } = useViewport();
  const breakpointWidth = 1330;
  const [tooltipSection, setTooltipSection] = useState<any>([])
  const tooltipRef = useRef<HTMLInputElement | any>(document.createElement('div'));

  useEffect(() => {
    fetchActionItems();
  }, [selectedTeam.__name, playersGroup, reload])

  useEffect(() => {
    setFirstLoadActionsItems(false)
  }, [])

  const triggerFetchActionItems = async () => {
    await fetchActionItems();
    setTriggerRefresh({
      ...triggerRefresh,
      actionItems: false,
    })
  }

  useEffect(() => {
    if( triggerRefresh.actionItems )
      triggerFetchActionItems();
  }, [triggerRefresh.actionItems])

  async function fetchActionItems() {
    setLoadingTable(true);
    const isSamePlayerNameSearch = currentPlayerNameSearch === playerNameSearch;
    const teamIdentifier = selectedTeam._id ?? selectedTeam.__name;
    const secondaryCacheOpts =  [teamIdentifier, `group-${playersGroup}`];
    const keyActionItems = CacheKeysTables(KeyActionItemsCache, secondaryCacheOpts);

    const response = await TEAMS.ExecuteCacheRequest({
      isForceDelete: !isSamePlayerNameSearch,
      cacheKey: keyActionItems,
      queryFn: () => TEAMS.GetActionItems(selectedTeam._id, playersGroup),
    });
    if (response.status) {
      useActionItems(response.data);
      setCurrentPlayerNameSearch(playerNameSearch);
    }
    setLoadingTable(false);
  }

  function hoverLocation(event, tooltipInfo) {
    let top = Number(event.clientY);
    let left = Number(event.clientX);
    if (Number(window.innerWidth) - Number(event.clientX) < 200) {
      left = Number(event.clientX) - 200;
    }
    if (Number(window.innerHeight) - Number(event.clientY) < 180) {
      top = Number(event.clientY) - 50;
    }
    tooltipRef.current.style.display = 'block';
    tooltipRef.current.style.inset = top + 'px 0px 0px ' + left + 'px';
    setTooltipSection(tooltipInfo);
  }

  function hideTooltip() {
    tooltipRef.current.style.display = 'none';
  }

  return (
    <FluidContainer overflow={true}>
      <ActionItemContainer>
        {loadingTable ?
          <div style={{ width: '100%', display: 'block', alignItems: 'center' }}>
            <Loader height="90px" />
          </div> :
          <>
            {width >= breakpointWidth ? <>
              <ActionItemColumn>
                <ActionItemCard filter={playerNameSearch} type='armSoreness' rows={actionItems.armSoreness} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='armStrength' rows={actionItems.armStrength} />
                <ActionItemCard filter={playerNameSearch} type='svr' rows={actionItems.svr} />
                <ActionItemCard filter={playerNameSearch} type='armFatigue' rows={actionItems.armFatigue} />
                <ActionItemCard filter={playerNameSearch} type='medicalAlerts' rows={actionItems.medicalAlerts} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
              </ActionItemColumn>
              <ActionItemColumn>
                <ActionItemCard filter={playerNameSearch} type='armReadiness' rows={actionItems.armReadiness} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='armRecovery' rows={actionItems.armRecovery} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='trainingAccountability' rows={actionItems.trainingAccountability} />
                <ActionItemCard filter={playerNameSearch} type='examAccountability' rows={actionItems.examAccountability} />
                <ActionItemCard filter={playerNameSearch} type='personalRecords' rows={actionItems.personalRecords || []} />
              </ActionItemColumn>
            </> :
              <ActionItemColumn>
                <ActionItemCard filter={playerNameSearch} type='armSoreness' rows={actionItems.armSoreness} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='armReadiness' rows={actionItems.armReadiness} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='armStrength' rows={actionItems.armStrength} />
                <ActionItemCard filter={playerNameSearch} type='armRecovery' rows={actionItems.armRecovery} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='svr' rows={actionItems.svr} />
                <ActionItemCard filter={playerNameSearch} type='trainingAccountability' rows={actionItems.trainingAccountability} />
                <ActionItemCard filter={playerNameSearch} type='armFatigue' rows={actionItems.armFatigue} />
                <ActionItemCard filter={playerNameSearch} type='examAccountability' rows={actionItems.examAccountability} />
                <ActionItemCard filter={playerNameSearch} type='medicalAlerts' rows={actionItems.medicalAlerts} hoverLocation={hoverLocation} hideTooltip={hideTooltip} />
                <ActionItemCard filter={playerNameSearch} type='personalRecords' rows={actionItems.personalRecords || []} />
              </ActionItemColumn>}
          </>
        }
        <TooltipLocations locations={tooltipSection} tooltipRef={tooltipRef} />
      </ActionItemContainer>
    </FluidContainer>
  );
};
